<div class="bg-shui-base-2 text-shui-text-strong text-xs w-full z-10 border-t-2 border-white/10">
    <div class="footer text-shs-white-1 text-xs flex items-center gap-2 sm:gap-4 p-1 sm:p-2 overflow-x-auto">
        <div class="text-xs text-shui-text-strong select-none whitespace-nowrap flex-shrink-0 px-2 py-1">
            Siemens Healthineers AG ©{{ year() }}
        </div>
        @for (link of links(); track $index; let last = $last) {
            <a
                class="text-xs text-shui-text-strong py-1 px-2 whitespace-nowrap flex-shrink-0 min-h-[32px] sm:min-h-auto flex items-center"
                [href]="link.url"
                target="_blank"
                >{{ `common.footer.${link.name}` | translate }}</a
            >
        }
    </div>
</div>
